import { render, staticRenderFns } from "./icon-funds.vue?vue&type=template&id=585f3aad&scoped=true&"
import script from "./icon-funds.vue?vue&type=script&lang=js&"
export * from "./icon-funds.vue?vue&type=script&lang=js&"
import style0 from "./icon-funds.vue?vue&type=style&index=0&id=585f3aad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f3aad",
  null
  
)

export default component.exports